import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PURCHASE_NOTIFICATIONS } from '../data/content';
const FIRST_DELAY = 9000;
const VISIBLE_MS = 5000;
const INTERVAL_MS = 15000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    const show = () => {
      setVisible(true);
      timers.current.push(window.setTimeout(() => setVisible(false), VISIBLE_MS));
      timers.current.push(window.setTimeout(() => setIndex(i => (i + 1) % PURCHASE_NOTIFICATIONS.length), VISIBLE_MS + 400));
    };
    const start = window.setTimeout(() => {
      show();
      const interval = window.setInterval(show, INTERVAL_MS);
      timers.current.push(interval);
    }, FIRST_DELAY);
    timers.current.push(start);
    return () => {
      timers.current.forEach(t => {
        window.clearTimeout(t);
        window.clearInterval(t);
      });
      timers.current = [];
    };
  }, []);
  const item = PURCHASE_NOTIFICATIONS[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-40 sm:bottom-5 sm:left-5" aria-live="polite" data-id="element-151" data-mp="jvjtseetwswx">
      <AnimatePresence data-id="element-152" data-mp="ex8is0csscd4">
        {visible ? <motion.div key={`${item.name}-${index}`} initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex max-w-[262px] items-center gap-2.5 rounded-lg border border-gold/25 bg-charcoal/95 py-2 pl-2.5 pr-3 shadow-premium backdrop-blur sm:max-w-[300px]" data-id="element-153" data-mp="1cjpej15vuhwr">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold/15" data-id="element-154" data-mp="3j9vlmmhosudo">
              <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-155" data-mp="3kr2gi4xr06uj" />
            </span>
            <p className="text-[11px] leading-snug text-cream/90 sm:text-[12px]" data-id="element-156" data-mp="3ppm0hzss78k9">
              <span className="font-semibold text-cream" data-id="element-157" data-mp="3asmxyqcse5wn">{item.name}</span> from{' '}
              {item.location} just got{' '}
              <span className="font-semibold text-gold" data-id="element-158" data-mp="3fqwtx36c5ajb">
                Functional Coach System™
              </span>
            </p>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}